import { isJust, isNothing, toMaybe } from "./maybe";
/**
 * Production browsers often abort in-flight fetch/XHR during hash navigations,
 * iframe embed hand-offs, or RUM beacons. Those reject as DOMException
 * AbortError with no app stack and are not actionable bugs.
 */
export function isBenignAbortError(error: unknown): boolean {
  if (error === null || typeof error !== "object") return false;
  const name = "name" in error ? String(error.name) : "";
  if (name === "AbortError") return true;
  const message = "message" in error ? String(error.message) : "";
  return /operation was aborted/i.test(message);
}

export function shouldDropSentryEvent(
  event: { exception?: { values?: { type?: string; value?: string }[] } },
  hint?: { originalException?: unknown },
): boolean {
  const original = hint?.originalException;
  if (isBenignAbortError(original)) return true;

  const valuesM = toMaybe(event.exception?.values);
  if (isNothing(valuesM) || valuesM.value.length === 0) return false;
  for (const entry of valuesM.value) {
    if (entry.type === "AbortError") return true;
    const valueM = toMaybe(entry.value);
    if (
      isJust(valueM) &&
      valueM.value.length > 0 &&
      /operation was aborted/i.test(valueM.value)
    ) {
      return true;
    }
  }
  return false;
}
